<script>
import Layout from '@/Shared/Layout'
export default { layout: Layout }
</script>

<script setup>
import { onMounted } from 'vue'
import { Head } from '@inertiajs/inertia-vue3'
import usePref from '@/Shared/usePref.js'
import Pagenation from './Pagenation'

const props = defineProps({
  pref: Object,
})

onMounted(() => {
  usePref(props.pref)
})
</script>

<template>
  <div class="about history">
    <Head title="A&F40年の歴史を、創業者・赤津孝夫が振り返る。" />
    <div class="pb-[50px] sm:pt-[20px]">
      <h2 class="page-title">
        History
        <small>A&amp;Fの歴史</small>
      </h2>

      <div class="m-auto px-[calc(5vw_+_10px)] xs:px-[40px] sm:px-[60px] lg:px-0 max-w-[500px] sm:max-w-[840px]">
        <div class="md:flex mt-[40px] mb-[50px] sm:mb-[60px] lg:mb-[80px] mx-auto">
          <div class="mb-[20px] md:mb-0 md:flex-none">
            <img class="mx-auto mb-[10px]" alt="赤津孝夫" src="https://img.aandf.co.jp/aandfcojp/img/corporate/about_akatsu_photo.jpg" />
            <img class="mx-auto" alt="赤津孝夫" src="https://img.aandf.co.jp/aandfcojp/img/corporate/about_akatsu_signature.png" />
          </div>
          <div class="md:flew-auto md:ml-[40px]">
            <h3 class="font-jpsans font-bold text-[18px] leading-[1.4] sm:text-[20px] lg:text-[22px] mb-[20px]">A&amp;F40年の歴史を、創業者・赤津孝夫が振り返る。</h3>
            <p class="text-sm leading-[2]">衣・食・住・を背負って心の赴くままウィルダネスに分け入り自然の営みを学ぶバックパッキングの旅は今年で40年目を迎えます。自然を敬い知恵、知識と道具を駆使しサバイバルをトレーニングするアウトドアの体験は、いつの時代になっても根源的に必要なアクティビティです。自然災害を目の当たりにしたとき、自然の前でいかに人は無力であるか知らしめられました。より多くの人がグレートアウトドアに親しみ自然尊重の叡智を養うことに、A&amp;Fはこれからも一層お役に立ちたいと願っています。</p>
          </div>
        </div>

        <Pagenation :page="1" />

        <div class="mt-10 md:mx-auto">
          <div class="section">
            <div class="left"><img src="https://img.aandf.co.jp/aandfcojp/img/corporate/about_img1_1.png" alt="" /></div>
            <div class="right">
              <h3>ナイフ一本で自然のなかでの生き方を学ぶ。<br class="hidden sm:block" />それがアウトドアの意義</h3>
              <p>1977年に創業しました。この頃はまだ個人で海外旅行に行くのも大変な時代でしたから、ひとつの商品を輸入するのにたくさんの書類を作って、大蔵省（現：財務省）の許可までとってね。それより以前、1973年にアメリカをバックパッキングで歩いたときに、道具に対する興味を覚えました。サバイバルの本などを読みあさるなかで、最初に興味を持ったのはナイフでした。ナイフはアウトドアの原点ですからね。そのころ、ナイフを手作りしている人がアメリカにいるというのを知って、翌年会いに行きましたね。その人がR.W.ラブレスというアメリカ最高峰のナイフ職人でした。ダイビングにものめり込んでいた時期でしたから、やはりいいナイフが欲しかったですね。その頃、「ライフタイムギャランティー」つまり生涯保証という考え方でナイフ造りをしているBUCKというブランドを知りました。ナイフを使って、研いで、すり減っていって、壊れちゃっても刃を交換してくれるんです。道具として、ものすごいこだわりを感じました。手は第2の頭脳と言われますが、わたしたち人間は手を動かすことによって様々な知恵を得てきました。ナイフを使うことによっていろいろな想像力も生まれてきます。遡れば古代に生きた先祖も、石器を手にし、創意工夫して厳しい自然を生き抜いてきたわけです。ナイフ一本で、自然のなかでの生き方を学ぶというのが本来のアウトドアの意義だと思います。</p>
            </div>
          </div>
          <div class="section">
            <div class="right"><img src="https://img.aandf.co.jp/aandfcojp/img/corporate/about_img1_2.png" alt="" /></div>
            <div class="left">
              <h3>パーコレターで入れた<br />アメリカの薄いコーヒー</h3>
              <p>前年に比べてキャンプ用品が充実した時期。COGHLAN'Sのフォールディングトースターはよく売れました。キャンプでトーストっていうのが新鮮でしたし、発想がユニーク。焚き火だと上手に焼けないですからね。COMETのパーコレーターもそう。キャンプでコーヒーが飲めるっていうのが良かった。アメリカの映画でパーコレーターが台所のコンロにあって、蓋の取っ手のところからコーヒーがコポコポ湧いているのが見えてね。アメリカンっていう薄いコーヒーをガブガブ飲むっていうのを初めて見たんだよ。あれってどういうふうに使うんだろう?って。ああ、これで入れるのがアメリカンなんだ！ってね。これもアメリカを教わった道具のひとつですね。</p>
            </div>
          </div>
          <div class="section">
            <div class="left"><img src="https://img.aandf.co.jp/aandfcojp/img/corporate/about_img1_3_1.png" alt="" /></div>
            <div class="right">
              <h3>サバイバルという考え方に<br />ロマンさえ感じた時代</h3>
              <p>LIFE-TOOLは、開高健さんが『PLAYBOY』っていう雑誌で取り上げてくれて、すごい売れたんですよ。サバイバルという考え方が物語を含んで、ロマンさえ感じさせるところがありました。</p>
              <p>ナイフ職人のR.W.ラブレスからすごくいい靴だと言われて紹介されたのがRUSSELLMOCCASIN。彼はここの靴しか履いていなかった。日本って単一民族だから、だいたい足の幅はEEとかEEEとかでカバーできちゃうところがあるんだけど、アメリカって様々な人がいるから、靴は自分の足にあわせて作るっていうのがあたり前なんですね。</p>
            </div>
          </div>
          <div class="section">
            <div class=""><img src="https://img.aandf.co.jp/aandfcojp/img/corporate/about_img1_3_2.png" alt="" /></div>
            <div class=""><img src="https://img.aandf.co.jp/aandfcojp/img/corporate/about_img1_3_3.png" alt="" /></div>
          </div>
        </div>

        <Pagenation :page="1" />
      </div>
    </div>
  </div>
</template>
